module.exports = __webpack_public_path__ + "static/media/Vanilla.8018e21c.jpg";